import { AdjacentType } from '@iotv/iotv-v3-types';
const debug = process.env.REACT_APP_DEBUG && false;
/** Unlinks objects selected in table */
export const handleUnLinkSelectedObjects = ({ matchedPrimary, adjacentFilter, selectedObjects, transactionFunctions }) => {
    debug && console.log(`handleUnLinkSelectedObjects unlinking via appState`, { matchedPrimary, tableObjects: selectedObjects });
    if (matchedPrimary && selectedObjects.length > 0) {
        if (adjacentFilter.adjacentType === AdjacentType.PARENT) {
            selectedObjects.forEach((item) => {
                transactionFunctions.unlink(item, matchedPrimary);
            });
        }
        else {
            selectedObjects.forEach((item) => {
                transactionFunctions.unlink(matchedPrimary, item);
            });
        }
    }
};
